/** 草稿预览 GeoJSON 写入 PREVIEW_* source */
import {
  PREVIEW_SOURCE,
  PREVIEW_LINE_SOURCE,
  PREVIEW_LINE,
  PREVIEW_POINTS,
  DRAFT_LINE_COLOR
} from './constants';
import { wgs84CoordsToDisplay } from './coords';

/**
 * @returns {'empty'|'sketch'|'drawn'|false}
 */
export function applyDraftPreview(map, points, kind, opts = {}) {
  if (!map) return false;
  const pointSrc = map.getSource(PREVIEW_SOURCE);
  const lineSrc = map.getSource(PREVIEW_LINE_SOURCE);
  if (!pointSrc || !lineSrc) return false;

  const emptyFc = { type: 'FeatureCollection', features: [] };
  if (!points || points.length === 0) {
    try {
      pointSrc.setData(emptyFc);
      lineSrc.setData(emptyFc);
    } catch (_) { /* ignore */ }
    return 'empty';
  }

  const displayPoints = wgs84CoordsToDisplay(points, map);
  const pointFeats = [];
  const lineFeats = [];

  const pushLine = (coords) => {
    if (!coords || coords.length < 2) return;
    lineFeats.push({
      type: 'Feature',
      geometry: { type: 'LineString', coordinates: coords },
      properties: {}
    });
  };

  if (kind === 'sketch') {
    pushLine(displayPoints);
    try {
      pointSrc.setData(emptyFc);
      lineSrc.setData({ type: 'FeatureCollection', features: lineFeats });
      if (map.getLayer(PREVIEW_LINE)) {
        map.setPaintProperty(PREVIEW_LINE, 'line-width', Math.max(2, opts.sketchWidth || 3));
        map.setPaintProperty(PREVIEW_LINE, 'line-color', opts.sketchColor || DRAFT_LINE_COLOR);
        map.setPaintProperty(PREVIEW_LINE, 'line-opacity', 1);
        try { map.moveLayer(PREVIEW_LINE); } catch (_) { /* ignore */ }
      }
    } catch (err) {
      console.warn('手绘预览失败:', err?.message || err);
    }
    return 'sketch';
  }

  displayPoints.forEach((c) => {
    pointFeats.push({
      type: 'Feature',
      geometry: { type: 'Point', coordinates: c },
      properties: {}
    });
  });
  if (displayPoints.length >= 2) {
    if (kind === 'polygon' && displayPoints.length >= 3) {
      const ring = [...displayPoints, displayPoints[0]];
      pointFeats.push({
        type: 'Feature',
        geometry: { type: 'Polygon', coordinates: [ring] },
        properties: {}
      });
      pushLine(ring);
    } else if (kind === 'rectangle' && displayPoints.length === 2) {
      const [a, b] = displayPoints;
      const ring = [
        [a[0], a[1]],
        [b[0], a[1]],
        [b[0], b[1]],
        [a[0], b[1]],
        [a[0], a[1]]
      ];
      pointFeats.push({
        type: 'Feature',
        geometry: { type: 'Polygon', coordinates: [ring] },
        properties: {}
      });
      pushLine(ring);
    } else {
      pushLine(displayPoints);
    }
  }
  try {
    pointSrc.setData({ type: 'FeatureCollection', features: pointFeats });
    lineSrc.setData({ type: 'FeatureCollection', features: lineFeats });
    if (!map.getLayer(PREVIEW_LINE) && map.getSource(PREVIEW_LINE_SOURCE)) {
      map.addLayer({
        id: PREVIEW_LINE,
        type: 'line',
        source: PREVIEW_LINE_SOURCE,
        layout: {
          'line-cap': 'round',
          'line-join': 'round',
          visibility: 'visible'
        },
        paint: {
          'line-color': DRAFT_LINE_COLOR,
          'line-width': 4,
          'line-opacity': 1
        }
      });
    }
    if (map.getLayer(PREVIEW_LINE)) {
      map.setPaintProperty(PREVIEW_LINE, 'line-width', 4);
      map.setPaintProperty(PREVIEW_LINE, 'line-color', DRAFT_LINE_COLOR);
      map.setPaintProperty(PREVIEW_LINE, 'line-opacity', 1);
      try { map.moveLayer(PREVIEW_LINE); } catch (_) { /* ignore */ }
    }
    if (map.getLayer(PREVIEW_POINTS)) {
      try { map.moveLayer(PREVIEW_POINTS); } catch (_) { /* ignore */ }
    }
  } catch (err) {
    console.warn('画线预览失败:', err?.message || err);
    return false;
  }
  return 'drawn';
}
